var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIcondevicesvayyarsquaresolid = function SvgIcondevicesvayyarsquaresolid(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Devices/SquareTemplate/devices.vayyar.square.solid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Devices/SquareTemplate/devices.vayyar.square.solid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    strokeWidth: 2,
    fill: "#D8D8D8",
    x: 40,
    y: 78,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2, 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#666666",
    fill: "#FFFFFF",
    cx: 38,
    cy: 38,
    r: 37.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9225,58.7975202 L37.5752394,55.1291052 C38.2236923,56.2003275 38.5479188,57.4231325 38.5479188,58.7975202 C38.5479188,60.1719079 38.2714738,61.4464084 37.7185839,62.6210219 L30.9225,58.7975202 Z M38.9092122,54.4210776 C39.7474157,56.1361557 40.1665174,57.7023921 40.1665174,59.1197869 C40.1665174,60.5371816 39.7474157,61.913677 38.9092122,63.2492731 L43.89,65.835 L43.89,51.87 L38.9092122,54.4210776 Z",
    id: "Combined-Shape",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#666666",
    fill: "#666666",
    cx: 38.07125,
    cy: 10.07,
    r: 1.495
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIcondevicesvayyarsquaresolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.devices.vayyar.square.solid.e7a8ca3b27d600bb4fbca4c9377b7459.svg";